import React from "react";
import ButtonComponent from "../../../../utils/button/ButtonComponent";
import Title from "../../../../utils/title/Title";
import { IHeaderType } from "../../../../types/types";
import { Colors } from "../../../../utils/colors/colors";
import { MediumModal } from "../../../../utils/modals/Modal";
import OneKBInitiativeIntakeForm from "../../../../components/modal-contents/OneKBInitiativeIntakeForm";
import { useModal } from "../../../../hooks/utils.hook";










const FAQIntro = () => {
  const { whiteColor, secondaryColor } = Colors();

  const {
    open,
    openModal,
    closeModal
  } = useModal();


  return (
    <>
      <Title
        textColor={whiteColor}
        text={"Frequently Asked Question"}
        style={{
          margin: "0",
          maxWidth: "470px",
        }}
        type={IHeaderType.h2}
      />

      <div
        className="bottom-text"
        style={{
          fontWeight: 400,
          maxWidth: "590px",
        }}
      >
        You’ve got questions, we’ve got answers. Here are some common questions we hear from business owners like you:
      </div>

      <ButtonComponent
        data-aos="fade-up"
        data-aos-once="true"
        bgColor={secondaryColor}
        text={"Get Started For Free"}
        click={openModal}
        isLoading={false}
        style={{
          color: whiteColor,
          maxWidth: "230px",
        }}
      />

      <MediumModal
        open={open}
        showCloseIcon={false}
        openModal={openModal}
        closeModal={closeModal}
        children={<OneKBInitiativeIntakeForm
          closeModal={closeModal}
        />
        }
      />
    </>
  );
};

export default FAQIntro;
